import EmployeeProfile from './EmployeeProfile';
import {useOutletContext} from 'react-router-dom';
import React from 'react';

const AdminEmployeeInformation = () => {
    const {data, isLoading} = useOutletContext();

    return <EmployeeProfile data={data} isLoading={isLoading}/>;
};

export default AdminEmployeeInformation;